import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { PermissionGuard } from "@/components/shared/guards/permission-guard";
import { ProjectDetailPage } from "@/features/projects";
import { PROJECT_TAB_VALUES } from "@/features/projects/shared/types";

const projectSearchSchema = z.object({
  tab: z.enum(PROJECT_TAB_VALUES).catch("models"),
  sort: z.enum(["asc", "desc"]).catch("asc"),
});

export const Route = createFileRoute("/projects/$projectId/")({
  validateSearch: projectSearchSchema,
  component: () => (
    <PermissionGuard module="projects">
      <ProjectDetailPage />
    </PermissionGuard>
  ),
});
